import { useContext } from "react";
import SPUndoContext from "../contexts/SPUndoProvider";

const useSPUndo = () => {
  return useContext(SPUndoContext);
};

export default useSPUndo;
